import React from 'react';

const MAX_POSES = 5;

const ReferencePoses = ({ poses, onChange }) => {
  const currentPoses = poses || [];

  const handleUpload = (shotIndex, e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      const next = [...currentPoses];
      // Ensure array is long enough
      while (next.length <= shotIndex) next.push(null);
      next[shotIndex] = ev.target.result;
      onChange(next);
    };
    reader.readAsDataURL(file);
    e.target.value = '';
  };

  const handleRemove = (shotIndex) => {
    const next = [...currentPoses];
    next[shotIndex] = null;
    onChange(next);
  };

  // Always show at least 3 slots
  const slotCount = Math.max(3, currentPoses.filter(Boolean).length + 1, currentPoses.length);
  const slots = Array.from({ length: Math.min(slotCount, MAX_POSES) }, (_, i) => i);

  return (
    <div style={{
      padding: '12px', background: '#f5f5f5', borderRadius: 4,
      border: '1px solid #e0e0e0'
    }}>
      <div style={{ fontSize: 12, marginBottom: 8, display: 'flex', alignItems: 'baseline', gap: 8 }}>
        <span style={{ fontWeight: 600, color: '#555' }}>Reference Poses</span>
        <span style={{ fontSize: 11, color: '#999' }}>Upload reference pose images for this pricelist. These will be available as reference images when building looks.</span>
      </div>

      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
        {slots.map(i => (
          <div key={i} style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 11, fontWeight: 500, color: '#555', marginBottom: 4 }}>
              Shot {i + 1}
            </div>
            {currentPoses[i] ? (
              <div style={{ position: 'relative' }}>
                <img
                  src={currentPoses[i]}
                  alt={`Shot ${i + 1}`}
                  style={{
                    width: 80, height: 120, objectFit: 'contain',
                    borderRadius: 4, border: '1px solid #ddd', display: 'block',
                    background: '#f0f0f0'
                  }}
                />
                <div style={{ display: 'flex', gap: 4, marginTop: 4, justifyContent: 'center' }}>
                  <label title="Replace" style={{
                    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                    width: 24, height: 24, background: '#e3f2fd',
                    border: '1px solid #90caf9', borderRadius: 4, cursor: 'pointer'
                  }}>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#1976d2" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M17 3a2.83 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
                    </svg>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={e => handleUpload(i, e)}
                      style={{ display: 'none' }}
                    />
                  </label>
                  <button
                    title="Remove"
                    onClick={() => handleRemove(i)}
                    style={{
                      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                      width: 24, height: 24, background: '#ffebee',
                      border: '1px solid #ef9a9a', borderRadius: 4, cursor: 'pointer'
                    }}
                    title="Remove"
                  >
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#d32f2f" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                    </svg>
                  </button>
                </div>
              </div>
            ) : (
              <label style={{
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                width: 80, height: 120, borderRadius: 4,
                border: '2px dashed #ccc', cursor: 'pointer',
                background: '#fff', fontSize: 10, color: '#999',
                flexDirection: 'column', gap: 2
              }}>
                <span style={{ fontSize: 18, lineHeight: 1 }}>+</span>
                Upload
                <input
                  type="file"
                  accept="image/*"
                  onChange={e => handleUpload(i, e)}
                  style={{ display: 'none' }}
                />
              </label>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReferencePoses;
